import {
    Navigate
} from 'react-router-dom';
import {
    Permission,
    hasPermission
} from './permissions';
import {
    JSX,
    useContext
} from 'react';
import {
    OrganizationContext
} from './OrganizationContext';

type Props = {
    permission: Permission;
    children: JSX.Element;
};

export default function RequireAccess({
    permission,
    children
}: Props) {
    const {
        selectedOrganization
    } = useContext(OrganizationContext);

    if (!hasPermission(permission, selectedOrganization.userRole)) {
        return <Navigate to="../sub" replace />;
    }

    return children;
}

export function RequireAccessComponent({
    permission,
    children
}: Props) {
    const {
        selectedOrganization
    } = useContext(OrganizationContext);

    if (!hasPermission(permission, selectedOrganization.userRole)) {
        return null;
    }

    return children;
}
